var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedDescription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 48095495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 48095494"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.6365 25.509C8.41512 23.5202 8.86909 19.8236 9.30684 18.5049L10.5228 18.2077C10.5228 18.2077 10.2148 16.3702 11.6037 14.5922C13.2736 12.4521 18.0456 8.19889 27.2222 7.69629C23.8661 11.4361 21.472 17.8078 20.8775 18.7481C19.6291 19.5966 18.4131 20.1695 18.4131 20.1695L19.521 21.2503C19.521 21.2503 13.3763 26.5304 9.6365 25.5144V25.509Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.083 12.9871C13.0844 18.2941 9.45813 25.0117 8.00977 29.4216",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.0098 29.7852C10.7556 29.3097 14.9061 27.1858 13.7928 29.7852C12.6795 32.3847 19.2566 28.5639 20.2996 27.937C21.267 27.3587 22.4776 26.7102 23.834 26.2886C26.4389 25.478 29.5518 26.3481 28.3845 29.2394",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 19.0098,
    cy: 19,
    r: 17.75,
    stroke: "black",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedDescription);
export default __webpack_public_path__ + "static/media/selected-description.d79ecdaa247e85ac2e1f408da06b9bf8.svg";
export { ForwardRef as ReactComponent };